import ErrorIcon from 'ocus-styleguide/src/assets/svg/alert-circle.svg';
import {
  importantInfo,
} from '~~/themes/ocus/common/alertColors';
import {
  alertSuccess,
  darkOrange,
  white,
} from '~~/themes/ocus/common/colors';

export const state = () => ({
  notifications: [],
  alerts: [],
  payoneerNotification: false,
});

export const mutations = {
  setPayoneerNotification(state, payload) {
    state.payoneerNotification = payload;
  },
  addAlert(state, {
    icon = null,
    textColor = white,
    backgroundColor = alertSuccess,
    title = '',
    description = '',
    timeout = 5,
  } = {}) {
    state.alerts.push({
      id: Math.random().toString(36).substr(2, 5),
      icon,
      textColor,
      backgroundColor,
      title,
      description,
      timeout,
    });
  },
  shiftAlert(state) {
    state.alerts.shift();
  },
  clearAlerts(state) {
    state.alerts = [];
  },
};

export const actions = {
  async alert({ commit }, alert = {}) {
    commit('addAlert', alert);
  },
  async alertError({ commit }, alert = {}) {
    commit('addAlert', { icon: ErrorIcon, backgroundColor: darkOrange, ...alert });
  },
  async alertInfo({ commit }, alert = {}) {
    commit('addAlert', { backgroundColor: importantInfo, ...alert });
  },
  async shiftAlert({ commit }) {
    commit('shiftAlert');
  },
  clearAlerts({ commit }) {
    commit('clearAlerts');
  },
};
